<template>
  <!-- VUE TEL INPUT -->
  <vue-tel-input
    ref="telInput"
    v-model="phoneNumber"
    default-country="VN"
    :input-options="{
      showDialCode: true,
      placeholder: 'Số điện thoại'
    }"
    :disabled="disabled"
    @country-changed="onCountryChanged"
    @input="onInput"
    @validate="onValidate"
  />
</template>

<script>
export default {
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      phoneNumber: null,
      isUpdatingFromParent: false
    }
  },

  watch: {
    value(nv, ov) {
      if (nv !== this.phoneNumber) {
        this.isUpdatingFromParent = true
        this.phoneNumber = nv
        this.$nextTick(() => {
          this.isUpdatingFromParent = false
        })
      }
    }
  },

  mounted() {
    // Initialize phoneNumber with value prop
    if (this.value) {
      this.phoneNumber = this.value
    }

    // Add paste event listener to handle paste operations
    this.$nextTick(() => {
      if (this.$refs.telInput && this.$refs.telInput.$el) {
        const inputElement = this.$refs.telInput.$el.querySelector('input')
        if (inputElement) {
          inputElement.addEventListener('paste', this.onPaste)
        }
      }
    })
  },

  beforeDestroy() {
    // Clean up paste event listener
    if (this.$refs.telInput && this.$refs.telInput.$el) {
      const inputElement = this.$refs.telInput.$el.querySelector('input')
      if (inputElement) {
        inputElement.removeEventListener('paste', this.onPaste)
      }
    }
  },

  methods: {
    formatPhoneNumber(phone) {
      if (!phone) return ''

      // Loại bỏ tất cả ký tự không phải số nhưng giữ dấu "+" nếu ở đầu
      const hasPlusAtStart = phone.startsWith('+')
      const cleanPhone = phone.replace(/\D/g, '')

      // Thêm lại dấu "+" nếu ban đầu có
      return hasPlusAtStart ? '+' + cleanPhone : cleanPhone
    },
    onValidate(phoneObject) {
      // Không cần validate logic cũ nữa vì ta tự format
    },
    onPaste(event) {
      // Get pasted text from clipboard
      const pastedText = event.clipboardData.getData('text')
      // Prevent default paste behavior to handle it manually
      event.preventDefault()

      // Format the pasted text
      const formattedNumber = this.formatPhoneNumber(pastedText)

      // Manually trigger the input logic
      if (this.isUpdatingFromParent) {
        return
      }

      // Update phoneNumber with formatted value
      this.$nextTick(() => {
        if (this.phoneNumber !== formattedNumber) {
          this.phoneNumber = formattedNumber
        }
      })

      // Emit the formatted value
      if (formattedNumber === '' || formattedNumber == null) {
        this.$emit('input', null)
      } else {
        this.$emit('input', formattedNumber)
      }
    },
    onInput(number, phoneObj) {
      // Không emit khi đang update từ parent để tránh vòng lặp
      if (this.isUpdatingFromParent) {
        return
      }

      // Format số điện thoại theo logic tùy chỉnh
      const formattedNumber = this.formatPhoneNumber(number)

      // Cập nhật lại phoneNumber với giá trị đã format
      this.$nextTick(() => {
        if (this.phoneNumber !== formattedNumber) {
          this.phoneNumber = formattedNumber
        }
      })

      this.$emit('phoneObj', phoneObj)

      // Emit giá trị đã format
      if (formattedNumber === '' || formattedNumber == null) {
        this.$emit('input', null)
      } else {
        this.$emit('input', formattedNumber)
      }
    },
    onCountryChanged(countryObject) {
      this.$emit('country-changed', countryObject)
    }
  }
}
</script>
